export const formatBookingDate = (record) =>
  record.multi_day && record.end_date ? `${record.booked_date} - ${record.end_date}` : record.booked_date

export const formatBookingTime = (record) => {
  if (record.multi_day) return record.start_time || record.time || "-"
  if (record.start_time && record.end_time) return `${record.start_time} - ${record.end_time}`
  return record.time || "-"
}
